import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

import {ref} from "vue";
import {user} from "@/api";
import {useApi} from "@/api/handler";
import store from "@/store";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'CaptchaLogin',
  setup(__props) {

const routers = useRouter();
const email = ref<string>('')
const code = ref<string>('')

const codeSent = ref<boolean>(false)
const countDown = ref<number>(60)
let counter: ReturnType<typeof setInterval> | null = null

function handleSendEmail(): void {
  if (codeSent.value) return
  if (email.value === '') {
    store.dispatch('snackBarModule/showError', '请正确填写邮箱')
    return
  }
  codeSent.value = true
  counter = setInterval(() => {
    countDown.value -= 1
    if (countDown.value === 0) {
      countDown.value = 60
      codeSent.value = false
      if (counter) clearInterval(counter)
    }
  }, 1000)
  useSendEmail()
}

function handleLogin(): void {
  useCaptchaLogin()
}

const useSendEmail = () => {
  useApi({api: user.SendEmail(email.value), tip: '发送成功'})
}

const useCaptchaLogin = () => {
  useApi({
    api: user.CaptchaLogin(email.value, code.value),
    onSuccess: callback => {
      window.localStorage.setItem("user", JSON.stringify(callback.data));
      setTimeout(() => {
        routers.push("/")}, 1000)
    },
    tip: '登录成功'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      density: "compact",
      placeholder: "请输入邮箱",
      "prepend-inner-icon": "mdi-email-outline",
      variant: "outlined",
      prefix: "   ",
      class: "mb-2",
      rounded: "",
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_text_field, {
        density: "compact",
        placeholder: "请输入验证码",
        prefix: "   ",
        variant: "outlined",
        rounded: "",
        modelValue: code.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
        "prepend-inner-icon": "mdi-security"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_btn, {
        class: "ml-4 code-button",
        color: "primary",
        disabled: codeSent.value,
        onClick: handleSendEmail
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(codeSent.value ? countDown.value + '秒后重试' : '获取验证码'), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_btn, {
      block: "",
      rounded: "",
      color: "blue-lighten-1",
      class: "mt-4",
      size: "large",
      onClick: handleLogin
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("登录")
      ])),
      _: 1,
      __: [2]
    })
  ], 64))
}
}

})